import { TangleTelemetryReporter } from './TelemetryReporter'

export const TelemetryReporter = TangleTelemetryReporter
